import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import Board from '../../../components/Board';

function CRM() {
    return (
        <DndProvider backend={HTML5Backend}>
            <Board />
        </DndProvider>
    );
}

export default CRM;